// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import DuplicatePinPlateDealerCriteria from './duplicate-pin-plate-dealer-criteria';
import LabeledCriteria from '../../../shared/components/labeled-criteria';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';

const DuplicatePinPlateReportCriteria = props =>
    <div className='duplicate-pin-plate-criteria'>
        <div className='criteria-container'>
            <div className='primary-criteria'>
                <DuplicatePinPlateDealerCriteria
                    onDealerSelect={props.onDealerSelect}
                    onSelectAllDealers={props.onSelectAllDealers}
                    selectedAccounts={props.selectedAccounts}
                    selectedDealers={props.selectedDealers}
                />
            </div>
            <div className='secondary-criteria'>
                <LabeledCriteria
                    className='pin-criteria'
                    isRequired={false}
                    label='PIN'
                    maxLength='17'
                    onInputChange={props.onPinInputChange}
                    placeholder='PIN'
                    type='text'
                    value={props.pin}
                />
            </div>
        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateReport}
            showExport={true}
            showReport={true}
        />
    </div>;

DuplicatePinPlateReportCriteria.displayName = 'DuplicatePinPlateReportCriteria';
DuplicatePinPlateReportCriteria.propTypes = {
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    onCreateReport: PropTypes.func.isRequired,
    onDealerSelect: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onPinInputChange: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    pin: PropTypes.string.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired
};

export default DuplicatePinPlateReportCriteria;



// WEBPACK FOOTER //
// ./src/reports/duplicate-pin-plate/components/duplicate-pin-plate-report-criteria.js